import { useState } from "react";
import styles from "./styles.module.css";
import { Grid, MenuItem } from "@mui/material";
import CustomTextField from "../utils/CustomFields/CustomTextField";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ButtonRed from "../utils/CustomFields/ButtonRed";
import ButtonGray from "../utils/CustomFields/ButtonGray";
import { CREDIT_LIMIT_TYPES } from "const";

function EditCustomer({ customer, closeDialog, editCustomerHandler, onClose }) {
  const [data, setData] = useState({
    ...customer,
    credit_limit_type: customer?.credit_limit <= 0 ? CREDIT_LIMIT_TYPES.CREDIT : CREDIT_LIMIT_TYPES.ADVANCE,
    balance_type: customer?.balance <= 0 ? CREDIT_LIMIT_TYPES.CREDIT : CREDIT_LIMIT_TYPES.ADVANCE,
    credit_limit: Math.abs(customer?.credit_limit) || "",
    balance: Math.abs(customer?.balance) || "",
  });

  const handleEditCustomer = () => {
    if (!data.name || !data.mobile) {
      return;
    }

    const creditLimit = Number(data.credit_limit) || 0;
    const adjustedCreditLimit =
      data.credit_limit_type === CREDIT_LIMIT_TYPES.CREDIT ? -Math.abs(creditLimit) : Math.abs(creditLimit);

    const balance = Number(data.balance) || 0;
    const adjustedBalance = data.balance_type === CREDIT_LIMIT_TYPES.CREDIT ? -Math.abs(balance) : Math.abs(balance);

    const payload = {
      ...data,
      credit_limit: adjustedCreditLimit,
      balance: adjustedBalance,
    };

    editCustomerHandler(payload);
  };

  return (
    <div className={styles.popupOverlay}>
      <div className={styles.popupContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.closeIcoSection}>
          <CloseRoundedIcon onClick={onClose} className={styles.icon} />
        </div>
        <div className={styles.headerSection} style={{ paddingBottom: "15px" }}>
          <div>
            <h2>Edit Customer</h2>
            <h4>Modify customer details and keep information up to date.</h4>
          </div>
        </div>

        <Grid container spacing={2} className={styles.contentArea} mb={2}>
          <Grid item xs={12}>
            <CustomTextField
              label="Name"
              placeholder="Enter name"
              value={data?.name || ""}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Mobile"
              placeholder="Enter mobile"
              value={data?.mobile || ""}
              onChange={(e) => setData({ ...data, mobile: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="Location"
              placeholder="Enter location"
              value={data?.location || ""}
              onChange={(e) => setData({ ...data, location: e.target.value })}
            />
          </Grid>

          <Grid item xs={12}>
            <CustomTextField
              label="GSTIN"
              placeholder="Enter GSTIN"
              value={data?.trn_number || ""}
              onChange={(e) => setData({ ...data, trn_number: e.target.value })}
            />
          </Grid>

          <Grid item xs={5}>
            <CustomTextField
              select
              label="Credit Type"
              value={data.credit_limit_type}
              onChange={(e) => setData({ ...data, credit_limit_type: e.target.value })}
              sx={{
                "& .MuiSelect-select": {
                  color: data.credit_limit_type === CREDIT_LIMIT_TYPES.CREDIT ? "red" : "green",
                },
              }}
            >
              <MenuItem value={CREDIT_LIMIT_TYPES.CREDIT}>Credit</MenuItem>
              <MenuItem value={CREDIT_LIMIT_TYPES.ADVANCE}>Advance</MenuItem>
            </CustomTextField>
          </Grid>

          <Grid item xs={7}>
            <CustomTextField
              label="Credit Limit"
              placeholder="0.00"
              value={data?.credit_limit || ""}
              onChange={(e) => setData({ ...data, credit_limit: e.target.value })}
            />
          </Grid>

          <Grid item xs={5}>
            <CustomTextField
              select
              label="Balance Type"
              value={data.balance_type}
              onChange={(e) => setData({ ...data, balance_type: e.target.value })}
              sx={{
                "& .MuiSelect-select": {
                  color: data.balance_type === CREDIT_LIMIT_TYPES.CREDIT ? "red" : "green",
                },
              }}
            >
              <MenuItem value={CREDIT_LIMIT_TYPES.CREDIT}>Credit</MenuItem>
              <MenuItem value={CREDIT_LIMIT_TYPES.ADVANCE}>Advance</MenuItem>
            </CustomTextField>
          </Grid>

          <Grid item xs={7}>
            <CustomTextField
              label="Balance"
              placeholder="0.00"
              value={data?.balance || ""}
              onChange={(e) => setData({ ...data, balance: e.target.value })}
            />
          </Grid>
        </Grid>

        <div className={styles.actionButtons}>
          <ButtonGray onClick={closeDialog}>Cancel</ButtonGray>
          <ButtonRed onClick={handleEditCustomer}>Submit</ButtonRed>
        </div>
      </div>
    </div>
  );
}

export default EditCustomer;
